import modSerializer from '@serializers/modSerializer.js'
import { myTeamsStore, modStore, store } from '@stores'
import { KEYS_COGS_MOD } from '@config/storeKeys.js'
import { NEW_RESOURCE_ID } from '@config'
import { clone } from '@helpers/utils.js'
import { readonly, ref } from 'vue'

const { updateStore, getStore, createStore } = store()

// used for resetting the current mod being edited
const cogsModCloneState = ref(null)

export default function ({ clear = false } = {}) {
  const cogsMod = getStore(KEYS_COGS_MOD)
  if (clear) {
    clearCogsMod()
  }

  const { addMod } = modStore()
  const { updateModTeam, addTeamLeader } = myTeamsStore()

  function addNewMod(gameNameId) {
    createStore(
      KEYS_COGS_MOD,
      modSerializer.getNew({
        id: NEW_RESOURCE_ID,
        game_name_id: gameNameId,
      })
    )
  }

  function addCogMod(gameNameId, mod, save = true, transform = true) {
    const _mod = transform ? modSerializer.transform(mod) : mod
    updateStore(KEYS_COGS_MOD, _mod)
    cogsModCloneState.value = clone(_mod)

    if (save) saveMod(gameNameId)
  }

  function saveMod(
    gameNameId,
    { newMod = null, updateTeamLeader = false } = {}
  ) {
    if (newMod) addCogMod(gameNameId, newMod, false)

    if (updateTeamLeader && cogsMod.value?.name_id) {
      updateModTeam(cogsMod.value)
      addTeamLeader('mod', cogsMod.value.id, cogsMod.value.name_id)
    }

    addMod(gameNameId, cogsMod.value)
    cogsModCloneState.value = clone(cogsMod.value)
  }

  function updateModField(field, value) {
    if (!cogsMod.value) return

    const updatedMod = { ...cogsMod.value, [field]: value }
    updateStore(KEYS_COGS_MOD, updatedMod)
  }

  function updateModObjField(key, input, value) {
    if (!cogsMod.value) return

    const updatedMod = clone(cogsMod.value)

    updatedMod[key][input] = value
    updateStore(KEYS_COGS_MOD, updatedMod)
  }

  function clearCogsMod() {
    cogsModCloneState.value = null
    createStore(KEYS_COGS_MOD, null)
  }

  return {
    cogsModClone: readonly(cogsModCloneState),
    updateModObjField,
    updateModField,
    clearCogsMod,
    addNewMod,
    addCogMod,
    saveMod,
    cogsMod,
  }
}
